'use client';

import { Check } from 'lucide-react';
import * as React from 'react';

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from '@/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

export function ModelSelector({ ...props }: React.ComponentProps<typeof Popover>) {
  return <Popover {...props} />;
}

export function ModelSelectorTrigger({ ...props }: React.ComponentProps<typeof PopoverTrigger>) {
  return <PopoverTrigger {...props} />;
}

export function ModelSelectorContent({
  title = 'Model selector',
  className,
  children,
  side = 'top',
  align = 'start',
  sideOffset = 8,
  ...props
}: React.ComponentProps<typeof PopoverContent> & { title?: React.ReactNode }) {
  return (
    <PopoverContent
      side={side}
      align={align}
      sideOffset={sideOffset}
      className={cn('w-[260px] p-0', className)}
      {...props}
    >
      <h2 className="sr-only">{title}</h2>
      {children}
    </PopoverContent>
  );
}

export function ModelSelectorDialog({ className, ...props }: React.ComponentProps<typeof Command>) {
  return <Command className={cn('h-full w-full', className)} {...props} />;
}

export function ModelSelectorInput({ ...props }: React.ComponentProps<typeof CommandInput>) {
  return <CommandInput {...props} />;
}

export function ModelSelectorList({
  className,
  ...props
}: React.ComponentProps<typeof CommandList>) {
  return <CommandList className={cn('max-h-[280px]', className)} {...props} />;
}

export function ModelSelectorEmpty({ ...props }: React.ComponentProps<typeof CommandEmpty>) {
  return <CommandEmpty {...props} />;
}

export function ModelSelectorGroup({ ...props }: React.ComponentProps<typeof CommandGroup>) {
  return <CommandGroup {...props} />;
}

export function ModelSelectorSeparator({
  ...props
}: React.ComponentProps<typeof CommandSeparator>) {
  return <CommandSeparator {...props} />;
}

export function ModelSelectorItem({
  className,
  ...props
}: React.ComponentProps<typeof CommandItem>) {
  return <CommandItem className={cn('flex items-center justify-between', className)} {...props} />;
}

export function ModelSelectorName({ className, ...props }: React.ComponentProps<'span'>) {
  return <span className={cn('text-sm', className)} {...props} />;
}

export function ModelSelectorSelectedIcon({
  className,
  ...props
}: React.ComponentProps<typeof Check>) {
  return <Check className={cn('h-3.5 w-3.5 text-primary', className)} {...props} />;
}
